package com.eladfinish.bible.contest.ui.common

import androidx.compose.foundation.layout.RowScope
import androidx.compose.foundation.layout.padding
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.TextUnit
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.eladfinish.bible.contest.common.gender.HebrewGender
import dev.icerock.moko.resources.StringResource

@Composable
fun RowScope.ActionButton(
    stringResource: StringResource,
    onClick: () -> Unit,
    onLongClick: () -> Unit = {},
    hebrewGender: HebrewGender,
    fontSize: TextUnit = 18.sp,
    isDebug: Boolean = false,
) {
    AppActionButton(
        modifier = Modifier
            .weight(1f)
            .padding(5.dp),
        stringResource = stringResource,
        onClick = onClick,
        onLongClick = onLongClick,
        hebrewGender = hebrewGender,
        fontSize = fontSize,
        isDebug = isDebug,
    )
}
